import type { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';

const getVehicleSummary = (
  vehicle: APIPersonalAutoApplicationFormVehicle,
  index: number,
) => {
  return `${vehicle.model_year} ${vehicle.make} ${vehicle.model}, VIN: ${
    vehicle.vin
  } (Vehicle ${index + 1})`;
};

export default getVehicleSummary;
